import { useCancelTradeSaleMutation } from "@fero/hooks";
import { LoadingButton } from "@mui/lab";
import { Button, Modal, Stack, Typography } from "@mui/material";
import { LoadingActionButton } from "components/widgets/buttons/loading-action-button/loading-action-button";
import type React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";

export const CancelPurchaserRequestButton = ({
  purchaseRequestId,
}: {
  purchaseRequestId: string;
}) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const cancelTradeSaleMutation = useCancelTradeSaleMutation();
  const history = useHistory();
  const handleModalConfirm = async () => {
    await cancelTradeSaleMutation.mutateAsync({
      purchaseRequestId: purchaseRequestId,
    });
    history.go(0);
  };

  return (
    <>
      <LoadingButton
        variant="outlined"
        onClick={() => setIsCancelModalOpen(true)}
      >
        Cancel Request
      </LoadingButton>
      <CancelConfirmationModal
        open={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        onConfirm={handleModalConfirm}
      />
    </>
  );
};

interface CancelConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="cancel-confirmation-modal"
    >
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          borderRadius: 1,
          p: 4,
          gap: 2,
        }}
      >
        <Typography variant="h6" id="cancel-confirmation-modal">
          Are you sure you wish to cancel this order?
        </Typography>

        <Typography>
          You must manually update <strong>Vision</strong> and communicate any
          relevant changes to the <strong>client & storage location.</strong>
        </Typography>

        <Typography>A notification will be sent to the purchaser.</Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={{ mt: 2 }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <LoadingActionButton
            variant="contained"
            loading={loading}
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              setLoading(false);
            }}
          >
            Confirm Cancellation
          </LoadingActionButton>
        </Stack>
      </Stack>
    </Modal>
  );
};
